import React from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import { Paper } from '@material-ui/core';
import PageLayout from '../../common/PageLayout';
import CommonPage from '../../common/CommonPage';
import CommonTable from '../../common/CommonTable';

@observer
export default class AuditConfigContainer extends CommonPage {
  constructor() {
    super();
    this.state = {
      audit_companies: [],
      currentPage: 0,
      totalItems: 0,
    };
  }

  componentDidMount() {
    this.callPageSelectFilter(this.state.currentPage, null, 75, null);
  }

  callPageSelectFilter(page = 0, items = {}, rowPerPage = 75, type) {
    const offset = page * rowPerPage;
    const { url } = this.getAuditMetadata();

    this.action.execute('get', `${this.APIEndpoints.AUDIT}/${url}?offset=${offset}&limit=${rowPerPage}`, 'audit_companies')
      .then(r => {
        this.setState({ 
          audit_companies: r.data.data,
          currentPage: page,
          totalItems: r.data.total
        });
      });
  }

  getAuditMetadata() { 
    const { language } = this.store;
    const isAuditUser = window.location.href.includes('users');
    const isAuditTickets = window.location.href.includes('tickets');
    const isAuditCompany = window.location.href.includes('company');
    const isAuditArticles = window.location.href.includes('solution');
    const isAuditCatalog = window.location.href.includes('catalog');
    const isAuditFlowApproveGmud = window.location.href.includes('flow-approve-gmud');
    const isAuditForm = window.location.href.includes('form');
    const isAuditPortal = window.location.href.includes('service-portal');

    switch (true) {
      case isAuditUser:
        return { name: language.USERS, url: 'users' };
      case isAuditTickets:
        return { name: language.TICKETS, url: 'tickets' };
      case isAuditCompany:
        return { name: language.COMPANY, url: 'company' };
      case isAuditArticles:
        return { name: language.KNOWLEDGE_BASE, url: 'solution' };
      case isAuditCatalog:
        return { name: language.CATALOG };
      case isAuditFlowApproveGmud:
        return { name: language.GMUD_FLOW };
      case isAuditForm:
        return { name: language.FORMS };
      case isAuditPortal:
        return { name: language.SERVICES_PORTAL, url: 'service-portal' };
      default:
        return { name: 'Audit', url: '' };
    }
  }

  render() {
    const isAuditUser = window.location.href.includes('users');
    const isAuditSolution = window.location.href.includes('solution');
    const isAuditTickets = window.location.href.includes('tickets');

    const { name } = this.getAuditMetadata();
    const { language } = this.store;

    let columns = [
      { key: 'company', label: name, style: { width: 100 } },
      { key: 'responsible', label: language.RESPONSIBLE, style: { width: 100 } },
      { key: 'dt_cad', label: language.DATE, style: { width: 80 } },
      { key: 'action', label: language.ACTION },
    ];

    if (isAuditSolution) {
      columns = [
        { key: 'solution', label: name },
        { key: 'responsible', label: language.RESPONSIBLE, style: { width: 100 } },
        { key: 'dt_cad', label: language.DATE, style: { width: 80 } },
        { key: 'action', label: language.ACTION },
      ];
    }

    if (isAuditUser) {
      columns = [
        { key: 'affected', label: language.USER, style: { width: 100 } },
        { key: 'email', label: language.EMAIL },
        { key: 'dt_cad', label: language.DATE, style: { width: 80 } },
        { key: 'responsible', label: language.RESPONSIBLE, style: { width: 100 } },
        { key: 'action', label: language.ACTION },
      ];
    }

    if (isAuditTickets) {
      columns = [
        { key: 'ticket', label: language.TICKET, style: { width: 80 } },
        { key: 'user_name', label: language.RESPONSIBLE, style: { width: 100 } },
        { key: 'dt_cad', label: language.DATE, style: { width: 80 } },
        { key: 'action', label: language.ACTION },
      ];
    }

    const data = this.state.audit_companies.map(a => {
      if (isAuditTickets) {
        return {
          ticket: a.ticket,
          user_name: a.user_name,
          dt_cad: moment(a.dt_cad).format('DD/MM/YYYY HH:mm:ss'),
          action: (
            <p style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={{ __html: a.data }}>
            </p>
          ),
        };
      } else {
        return {
          ...a,
          dt_cad: moment(a.dt_cad).format('DD/MM/YYYY HH:mm:ss'),
          action: (
            <p style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={{ __html: a.action }}>
            </p>
          ),
        };
      }
    });

    return (
      <PageLayout
        icon={<div className="auditIcon titleIconSize" />}
        title={`${language.AUDIT} - ${name}`}
        rightElements={[]}
      >
        <Paper style={{ padding: 0, marginTop: '-1rem' }}>
          <CommonTable
            title={''}
            data={data}
            columns={columns}
            language={language}
            qtdRow={data.length}
            hideFooterToolbar={true}
            isAutomaticPagination={false}
            currentPage={this.state.currentPage}
            countTotal={this.state.totalItems}
            callPageSelectFilter={(page, values, rowsPerPage, type) =>
              this.callPageSelectFilter(page, values, rowsPerPage, type)
            }
          />
        </Paper>
      </PageLayout>
    );
  }
}